module.exports = "/img/_/_/_/assets/images/creeper/book/common//19.jpg?73442b919e3cacabe227baf3bb921ea5";